import React, {FunctionComponent, useEffect, useState, useRef } from 'react';
import './Modal.scss';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { removeModalOpen, addModalOpen} from "./helper";

const Modal: FunctionComponent<any> = (props) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const lastFocusedElementRef = useRef<HTMLElement | null>(null);
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  const onClose = () => {
    removeModalOpen();
    props.onClose();
  }

  const onFirstClick = (e: React.SyntheticEvent) => {
    removeModalOpen();
    if(props.onFirstClick) {
      props.onFirstClick(e);
    }
  }

  const onSecondClick = () => {
    removeModalOpen();
    props.onSecondClick();
  }

  const onFirstClickSection2 = () => {
    removeModalOpen();
    props.onFirstClickSection2();
  }

  const onSecondClickSection2 = () => {
    removeModalOpen();
    props.onSecondClickSection2();
  }

  useEffect(() => {
    if (props.show !== show) {
      setShow(props.show);
      if(props.show === true) {
        addModalOpen();
      } else {
        removeModalOpen();
      }
    }
  }, [props.show, show])

  /* close modal with keyboard ESC */
  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if(e.key === "Escape" && show) {
        onClose();
      }
    }
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [show, onClose])

  /* focus handling */
  function handleKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if(e.key !== "Tab" || !modalRef.current) {
      return;
    }
    const focusable = modalRef.current.querySelectorAll<HTMLElement>(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) {
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  useEffect(() => {
    if(show) {
      lastFocusedElementRef.current = document.activeElement as HTMLElement;

      const focusable = modalRef.current?.querySelector<HTMLElement>(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if(document.querySelector("body")?.classList.contains("using-keyboard")) {
        focusable?.focus();
      }
    } else {
      if(document.querySelector("body")?.classList.contains("using-keyboard")) {
        lastFocusedElementRef.current?.focus();
      }
    }
  }, [show])

  return (show ?
    <div className="modal gcap-modal--language success-modal-container" role="dialog" aria-modal="true" data-testid={'Modal'} ref={modalRef} onKeyDown={handleKeyDown} aria-labelledby={props.ariaLabelled ? props.title : ""}>
        <div className="container">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className={props.isWithForm ? "modal-content success-modal-content isWithForm" : props.isChangeImageModal ? "modal-content success-modal-content isChangeImageModal" : "modal-content success-modal-content"}>
                    <div className={props.description && props.descriptionSection2 ? "modal-body with-section-2" : "modal-body"}>
                      { props.onClose ?
                        <button type="button" className={props.isChangeImageModal ? "btn btn-icon btn-icon-air close" : "close"} aria-label={t("common.close")} onClick={onClose}>
                            <i className="gc-icon-functional-close" aria-hidden="true"></i>
                        </button>
                      : null }
                      { !props.noIcon ?
                        <div className="modal-lang--icon">
                          <i
                            className={props.icon ? props.icon : "gc-icon-functional-attention-2-col"}
                            aria-hidden="true"
                          >
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </div>
                      : null }

                      {props.content ?
                        <div className={props.descriptionClass ? `description ${props.descriptionClass}` : "description"}>
                          {props.content}
                        </div>
                      : null }

                      {props.title ?
                        <div className={props.titleClass ? `title headline-bold-fs4 ${props.titleClass}` : "title headline-bold-fs4"}>
                          <h2>{props.title}</h2>
                        </div> : null
                      }

                      {props.removeTagDescriptionP ?
                        <div className={props.descriptionClass ? `description paragraph-main-fs8 ${props.descriptionClass}` : "description paragraph-main-fs8"}>
                          {props.description}
                        </div>
                      : (props.description ?
                          <div className="description">
                            <p className={props.descriptionClass ? `paragraph-main-fs8 ${props.descriptionClass}` : "paragraph-main-fs8"}>
                              {props.description}
                            </p>
                          </div>
                        : null)
                      }

                      {props.linkTitle || props.linkTitleSecond ? (
                        <div className="modal-lang--cta">

                          {props.type ?
                            (props.type === "button" ?
                              (
                                <button type="button" onClick={onFirstClick} className={props.styleType === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitle}
                                </button>
                              ) : props.type === "link" ?
                              (
                                <Link to={props.to} onClick={onFirstClick} className={props.styleType === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitle}
                                </Link>
                              ) : (
                                <a href={props.to} onClick={onFirstClick} className={props.styleType === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitle}
                                </a>
                              )
                            )
                          : null }

                          {props.typeSecond ?
                            (props.typeSecond === "button" ?
                              (
                                <button type="button" onClick={onSecondClick} className={props.styleTypeSecond === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitleSecond}
                                </button>
                              ) :
                              (
                                <Link to={props.toSecond} onClick={removeModalOpen} className={props.styleTypeSecond === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitleSecond}
                                </Link>
                              )
                            )
                          : null }

                        </div>)
                      : null }

                      {(props.descriptionSection2 ?
                        <div className="descriptionSection2">
                          <p className={props.descriptionClassSection2 ? `paragraph-main-fs8 ${props.descriptionClassSection2}` : "paragraph-main-fs8"}>
                            {props.descriptionSection2}
                          </p>
                        </div>
                      : null )}

                      { props.linkTitleSection2 || props.linkTitleSecondSection2 ?
                        <div className="modal-lang--cta">

                          { props.typeSection2 ?
                            (props.typeSection2 === "button" ?
                              (
                                <button type="button" onClick={onFirstClickSection2} className={props.styleTypeSection2 === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitleSection2}
                                </button>
                              ) :
                              ( props.toSection2 ?
                                <Link to={props.toSection2} onClick={removeModalOpen} className={props.styleTypeSection2 === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitleSection2}
                                </Link> : null
                              )
                            )
                          : null }

                          {props.typeSecondSection2 ?
                            (props.typeSecondSection2 === "button" ?
                              (
                                <button type="button" onClick={onSecondClickSection2} className={props.styleTypeSecondSection2 === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitleSecondSection2}
                                </button>
                              ) :
                              (
                                <Link to={props.toSecondSection2} onClick={removeModalOpen} className={props.styleTypeSecondSection2 === "secondary" ? "btn btn-secondary" : "btn btn-primary"}>
                                  {props.linkTitleSecondSection2}
                                </Link>
                              )
                            )
                          : null }

                        </div>
                      : null }

                      {props.children}

                    </div>
                </div>
            </div>
        </div>
    </div>
    :
    null)
};

export default Modal;
